import { Component } from '@angular/core';

@Component({
  templateUrl: './disclaimer.component.html',
})
export class DisclaimerComponent {}
